// extracted by mini-css-extract-plugin
export default {"ProductInfo":"ProductInfo_ProductInfo__9r6bZ","productDescription":"ProductInfo_productDescription__FoCDo"};